module.exports = "<nv-page [collectionParams]=\"collectionParams\"\n          [pageParams]=\"pageParams\">\n  <div *ngIf=\"document\">\n    <nv-generator [generator]=\"document\">\n\n    </nv-generator>\n  </div>\n</nv-page>\n\n\n"


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/app/pages/location/generators.location-page.component.html
// module id = ../../../../../src/app/pages/location/generators.location-page.component.html
// module chunks = 0